import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-offline-report-modal',
  templateUrl: './offline-report-modal.component.html',
  styleUrls: ['./offline-report-modal.component.scss']
})
export class OfflineReportModalComponent {
  includeSentenceFindings = false;

  constructor(
    public dialogRef: MatDialogRef<OfflineReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  cancel(): void {
    this.dialogRef.close(null);
  }

  download(): void {
    this.dialogRef.close({ includeSentenceFindings: this.includeSentenceFindings });
  }
}
